import { forwardRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { ReactPlayerYouTube } from './videoYouTube';
import { ReactPlayerFile } from './videoFile';
import { PlayerWrapper } from './styles';

const VideoPlayer = forwardRef((props, ref) => {
  const {
    type = '',
    className = '',
    onReady = () => {},
    onDuration = () => {},
    onProgress = () => {},
    onEnded = () => {},
    progressInterval = 1000,
    url = null,
    playing,
    loop = false,
    controls = true,
    muted = true,
    width = '100%',
    height = '100%',
  } = props;

  const [hasWindow, setHasWindow] = useState(false);
  useEffect(() => {
    if (typeof window !== 'undefined') {
      setHasWindow(true);
    }
  }, []);

  return (
    <>
      {hasWindow && (
        <PlayerWrapper className={className}>
          {type === 'youtube' ? (
            <ReactPlayerYouTube
              ref={ref}
              url={url}
              progressInterval={progressInterval}
              className="react-youtube-player"
              playing={playing}
              onReady={onReady}
              onDuration={onDuration}
              onEnded={onEnded}
              onProgress={onProgress}
              loop={loop}
              controls={controls}
              muted={muted}
              width={width}
              height={height}
              volume={null}
              playsinline
            />
          ) : (
            <ReactPlayerFile
              ref={ref}
              url={url}
              progressInterval={progressInterval}
              className="react-file-player"
              playing={playing}
              onReady={onReady}
              onDuration={onDuration}
              onEnded={onEnded}
              onProgress={onProgress}
              loop={loop}
              controls={controls}
              muted={muted}
              width={width}
              height={height}
              volume={null}
              playsinline
            />
          )}
        </PlayerWrapper>
      )}
    </>
  );
});

VideoPlayer.propTypes = {
  type: PropTypes.string,
  className: PropTypes.string,
  onReady: PropTypes.func,
  onDuration: PropTypes.func,
  onProgress: PropTypes.func,
  onEnded: PropTypes.func,
  progressInterval: PropTypes.number,
  url: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.shape),
    PropTypes.string,
  ]),
  playing: PropTypes.bool.isRequired,
  loop: PropTypes.bool,
  controls: PropTypes.bool,
  muted: PropTypes.bool,
  width: PropTypes.string,
  height: PropTypes.string,
};

export default VideoPlayer;
